<template>
    <ListingsSearch />
</template>

<script>
    import ListingsSearch from "@/components/ListingsSearch.vue";

    export default {
        name: "Listings",
        components: {
            ListingsSearch,
        },
    };
</script>
